<template>
  <div class="edit-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/admin/index' }">数据概览</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/index' }">应用中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/shell/index' }">会议壳</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/shell/meeting-list' }">会议列表</el-breadcrumb-item>
      <el-breadcrumb-item>编辑会议</el-breadcrumb-item>
      <el-breadcrumb-item>{{editForm.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page-content">
      <div class="left">
        <div class="preview-panel" :style="'background-image: url(' + editForm.bg_img + ')'">
          <div class="header-area">
            <img :src="editForm.head_img" v-if="editForm.head_layout === 1"/>
            <div v-html="editForm.head_txt" v-if="editForm.head_layout === 2" :style="'color:' + editForm.head_txt_color"></div>
          </div>
          <div class="copyright" :style="'color:' + editForm.copyright_color">{{editForm.copyright}}</div>
          <div class="music" @click="musicplay" :class="{'rotating' : musicData.isrotating}" :style="'opacity:' + this.musicData.opacity">
            <div class="bgm-btn rotate" style="animation-play-state: paused;" ref="bgmBtn">
              <audio :src="editForm.bg_music" loop autoplay ref="audio" controls="controls" preload hidden></audio>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <el-steps :active="activeStep" align-center finish-status="success">
          <el-step title="基础信息"></el-step>
          <el-step title="页面设置"></el-step>
          <el-step title="微信分享"></el-step>
        </el-steps>
        <el-form label-position="top" :model="editForm" :rules="editRules" ref="editRef" label-width="auto" class="edit-form">
          <div class="step-content" v-show="activeStep === 0">
            <div class="form-content">
              <el-form-item label="会议标题" prop="title">
                <el-input v-model="editForm.title"></el-input>
              </el-form-item>
              <el-form-item label="会议开始时间" prop="start_time">
                <el-date-picker v-model="editForm.start_time" :default-value="Date.parse(new Date())" type="datetime" placeholder="选择日期时间" value-format="timestamp" @change="editStartTime"></el-date-picker>
                <el-checkbox v-model="editForm.start_time" :true-label="''" :false-label="Date.parse(new Date())">无限制</el-checkbox>
              </el-form-item>
              <el-form-item label="会议结束时间" prop="end_time">
                <el-date-picker v-model="editForm.end_time" type="datetime" :default-value="Date.parse(new Date())" placeholder="选择日期时间" value-format="timestamp" @change="editEndTime"></el-date-picker>
                <el-checkbox v-model="editForm.end_time" :true-label="''" :false-label="Date.parse(new Date())">无限制</el-checkbox>
              </el-form-item>
              <el-form-item label="版权信息" prop="copyright">
                <el-input v-model="editForm.copyright"></el-input>
              </el-form-item>
              <el-form-item label="是否需要注册浏览" prop="is_register">
                <el-radio-group v-model="editForm.is_register">
                  <el-radio :label="1">需要</el-radio>
                  <el-radio :label="2">不需要</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="注册是否自动审核" prop="auto_check">
                <el-radio-group v-model="editForm.auto_check">
                  <el-radio :label="1">自动</el-radio>
                  <el-radio :label="2">手动</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="门票是否自动审核" prop="auto_ticket">
                <el-radio-group v-model="editForm.auto_ticket">
                  <el-radio :label="1">自动</el-radio>
                  <el-radio :label="2">手动</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <el-form-item class="step-btn-area">
              <el-button @click="activeStep = 1" type="primary">下一步</el-button>
            </el-form-item>
          </div>
          <div class="step-content" v-show="activeStep === 1">
            <div class="form-content">
              <el-form-item label="背景图片" prop="bg_img">
                <upload :url="editForm.bg_img" :filed="'bg_img'" :max-num="1" @checked-files="checkedFiles" @del-select="delSelect"></upload>
              </el-form-item>
              <el-form-item label="顶部排版类型" prop="head_layout">
                <el-radio-group v-model="editForm.head_layout">
                  <el-radio :label="1">图片</el-radio>
                  <el-radio :label="2">文字</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="顶部文字" prop="head_txt">
                <el-input v-model="editForm.head_txt"></el-input>
              </el-form-item>
              <el-form-item label="顶部图片" prop="head_img">
                <upload :url="editForm.head_img" :filed="'head_img'" :max-num="1" @checked-files="checkedFiles" @del-select="delSelect"></upload>
              </el-form-item>
              <el-form-item label="顶部文字颜色" prop="head_txt_color">
                <el-color-picker v-model="editForm.head_txt_color" show-alpha></el-color-picker>
              </el-form-item>
              <el-form-item label="导航文字颜色" prop="nav_color">
                <el-color-picker v-model="editForm.nav_color" show-alpha></el-color-picker>
              </el-form-item>
              <el-form-item label="版权文字颜色" prop="copyright_color">
                <el-color-picker v-model="editForm.copyright_color" show-alpha></el-color-picker>
              </el-form-item>
              <el-form-item label="背景音乐" prop="bg_music">
                <upload :url="editForm.bg_music" :filed="'bg_music'" :max-num="1" @checked-files="checkedFiles" @del-select="delSelect"></upload>
              </el-form-item>
            </div>
            <el-form-item class="step-btn-area">
              <el-button @click="activeStep = 0" type="warning">上一步</el-button>
              <el-button @click="activeStep = 2" type="primary">下一步</el-button>
            </el-form-item>
          </div>
          <div class="step-content" v-show="activeStep === 2">
            <div class="form-content">
              <el-form-item label="微信分享图标" prop="wx_img">
                <upload :url="editForm.wx_img" :filed="'wx_img'" :max-num="1" @checked-files="checkedFiles" @del-select="delSelect"></upload>
              </el-form-item>
              <el-form-item label="微信分享标题" prop="wx_title">
                <el-input v-model="editForm.wx_title"></el-input>
              </el-form-item>
              <el-form-item label="微信分享内容" prop="wx_content">
                <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4}" placeholder="请输入内容" v-model="editForm.wx_content"></el-input>
              </el-form-item>
            </div>
            <el-form-item class="step-btn-area">
              <el-button @click="activeStep = 1" type="warning">上一步</el-button>
              <el-button @click="submitForm" type="success">提 交</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Upload from '../../../common/Upload'
export default {
  name: 'Edit',
  components: {
    Upload
  },
  data () {
    return {
      activeStep: 0,
      musicData: {
        isrotating: false,
        opacity: 0.4
      },
      editForm: {
        title: '',
        start_time: '',
        end_time: '',
        copyright: '',
        is_register: 2,
        auto_check: 1,
        auto_ticket: 1,
        bg_img: '',
        head_layout: 1,
        head_txt: '',
        head_img: '',
        head_txt_color: 'rgba(0,0,0,1)',
        nav_color: 'rgba(0,0,0,1)',
        copyright_color: 'rgba(0,0,0,1)',
        bg_music: '',
        wx_img: '',
        wx_title: '',
        wx_content: ''
      },
      editRules: {
        title: [
          { required: true, message: '请填写会议标题名称', trigger: 'blur' },
          { min: 1, max: 12, message: '长度在 1 到 12 个字符', trigger: 'blur' }
        ],
        bg_img: [
          { required: true, message: '请上传背景图片', trigger: 'blur' }
        ],
        wx_img: [
          { required: true, message: '请上传微信分享图标', trigger: 'blur' }
        ],
        wx_title: [
          { required: true, message: '请填写微信分享标题', trigger: 'blur' }
        ],
        wx_content: [
          { required: true, message: '请填写微信分享内容', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    // 获取信息
    this.getEditItem()
  },
  methods: {
    // 获取会议基础设置信息
    async getEditItem () {
      const { data: res } = await this.$http.get('/shell-meeting/' + this.$route.params.mId)
      if (res.status === 200) {
        this.editForm = res.data
        if (res.data.start_time === 0 || res.data.start_time === '') {
          this.editForm.start_time = ''
        } else {
          this.editForm.start_time = res.data.start_time * 1000
        }
        if (res.data.end_time === 0 || res.data.end_time === '') {
          this.editForm.end_time = ''
        } else {
          this.editForm.end_time = res.data.end_time * 1000
        }
      } else {
        this.$message.error(res.msg)
      }
    },
    // 提交表单
    submitForm () {
      this.$refs.editRef.validate(async (valid, item) => {
        if (valid) {
          const { data: res } = await this.$http.put('/shell-meeting/' + this.$route.params.mId, this.editForm)
          if (res.status === 200) {
            this.$message.success(res.msg)
            this.$refs.editRef.resetFields()
            await this.$router.push('/admin/apps/shell/meeting-list')
          }
        } else {
          this.$message.error('请检查表单必填项')
          return false
        }
      })
    },
    editStartTime (val) {
      this.editForm.start_time = val
    },
    editEndTime (val) {
      this.editForm.end_time = val
    },
    // 上传组件返回值
    checkedFiles (data) {
      this.editForm[data.filed] = data.url
    },
    // 删除已选择文件
    delSelect (field, item, pattern) {
      // 单文件删除
      if (pattern === 'single') {
        this.editForm[field] = ''
      } else {
        // 多文件删除
        const checkedIndex = this.editForm[field].findIndex(fileItem => fileItem === item)
        // 如果已包含了该文件则移除文件 和 checked 样式
        this.editForm[field].splice(checkedIndex, 1)
      }
    },
    musicplay () {
      if (this.$refs.audio.paused && this.editForm.bg_music) {
        this.musicData.isrotating = true
        this.musicData.opacity = 1
        window.sessionStorage.setItem('music', 'true')
        this.$refs.audio.play()
      } else {
        this.musicData.isrotating = false
        this.musicData.opacity = 0.4
        window.sessionStorage.setItem('music', 'false')
        this.$refs.audio.pause()
      }
    }
  }
}
</script>

<style scoped>
.page-content{
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
}
.page-content .left{
  width: 320px;
}
.page-content .right{
  flex: 1;
  max-width: 420px;
}
.step-content{
  margin-left: auto;
  margin-right: auto;
  background-color: rgba(255,255,255,0.5);
  position: relative;
  margin-top: 20px;
}
.step-content .form-content{
  height: calc(100vh - 471px);
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
.step-content .form-content::-webkit-scrollbar{
  width: 7px;
  height: 7px;
  background-color: #d3dce6;
}

/*定义滚动条轨道 内阴影+圆角*/
.step-content .form-content::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(64,158,255, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(64,158,255, 0.3);
  border-radius: 10px;
  background-color: #F5F5F5;
}

/*定义滑块 内阴影+圆角*/
.step-content .form-content::-webkit-scrollbar-thumb{
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(64,158,255, .1);
  -webkit-box-shadow: inset 0 0 6px rgba(64,158,255, .1);
  background-color: rgb(19, 206, 102);
}
.step-content .step-btn-area{
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(255,255,255,1);
  text-align: center;
  padding: 14px;
  margin-bottom: 0;
}
/deep/.el-step__title{
  font-size: 13px;
}
.page-content .left .preview-panel{
  background-color: rgba(0,0,0,0.1);
  height: calc(100vh - 324px);
  position: relative;
  background-size: cover;
}
.page-content .left .preview-panel .header-area{}
.page-content .left .preview-panel .header-area img{
  width: 100%;
}
.page-content .left .preview-panel .header-area div{
  padding: 20px;
  word-break: break-all;
}
.page-content .left .preview-panel .copyright{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px;
  word-break: break-all;
}
.page-content .left .preview-panel .music{
  position: absolute;
  top: 14px;
  right: 14px;
  width: 40px;
  height: 40px;
}
.page-content .left .preview-panel .music img{
  width: 100%;
  height: 100%;
}
.music{
  position: fixed;
  top: 20px;
  right: 20px;
  width: 30px;
  height: 30px;
  z-index: 200;
  border-radius: 15px;
}
.rotating{
  -webkit-animation: rotating 1.2s linear infinite;
  animation: rotating 1.2s linear infinite;
}
.music .bgm-btn{
  width: 100%;
  height: 100%;
  background-image: url('../../../../assets/img/shell/music.png');
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 15px;
}
@keyframes rotating {
  from {
    transform: rotate(0deg)
  }
  to {
    transform: rotate(1turn)
  }
}
</style>
